import React from "react";

function CallRequestModalSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <circle cx="16" cy="16" r="16" fill="#E9F0FF"></circle>
      <mask
        id="mask0_1053_30904"
        style={{ maskType: "alpha" }}
        width="32"
        height="32"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <circle cx="16" cy="16" r="16" fill="#fff"></circle>
      </mask>
      <g mask="url(#mask0_1053_30904)">
        <circle cx="18.411" cy="29.808" r="13.151" fill="#1C64F2"></circle>
        <path
          fill="#fff"
          d="M19.187 14.276s-.726 2.483.841 4.126c.86.898.765 2.369-.21 3.171-.784.65-2.026 1.185-4.052 1.261-1.567.058-2.638-.286-3.364-.764-1.338-.879-1.28-2.923.115-3.725 1.166-.669 2.408-2.254 1.777-6.018l4.893 1.949z"
        ></path>
        <path
          fill="#000"
          d="M15.48 23.12c-1.32 0-2.409-.267-3.23-.82a2.451 2.451 0 01-1.09-2.14c.019-.86.477-1.643 1.223-2.064 1.07-.61 2.236-2.1 1.644-5.711l-.077-.497 5.581 2.235-.076.248c-.02.039-.65 2.35.765 3.84.458.497.707 1.127.669 1.815a2.456 2.456 0 01-.88 1.757c-.994.822-2.408 1.261-4.224 1.319-.095.019-.21.019-.306.019zm-.803-10.334c.458 3.572-.822 5.139-1.988 5.807a1.855 1.855 0 00-.937 1.586 1.87 1.87 0 00.841 1.643c.784.515 1.854.764 3.192.707 1.682-.058 3.001-.459 3.88-1.185.402-.344.65-.821.688-1.356a1.88 1.88 0 00-.497-1.395c-1.376-1.452-1.108-3.438-.975-4.145l-4.204-1.662z"
        ></path>
        <path
          fill="#000"
          d="M14.638 12.824s-1.777-.134-2.6-1.146c-.764-.955-1.146-2.235-1.07-3.19.058-.936.421-3.573 2.734-4.299 2.313-.706 4.3-.038 5.065-.305.745-.268 1.51-.516 3.096-.287 1.415.21 2.81 3.515-.65 4.356-.095.019-.21.038-.305.057l-6.308.936.038 3.878z"
        ></path>
        <path
          fill="#fff"
          d="M14.696 9.997V8.564c0-.4.325-.707.707-.707h5.466s1.338 7.279-2.599 7.546c-3.937.268-4.415-3.247-4.415-3.247s-.88.095-1.204-.784c-.249-.668-.23-1.853.84-1.795.574.038.88.267 1.033.477a.094.094 0 00.172-.057z"
        ></path>
        <path
          fill="#000"
          d="M17.869 15.69c-3.173 0-4.053-2.465-4.244-3.267a1.44 1.44 0 01-1.242-.955c-.191-.535-.23-1.28.115-1.758.152-.21.458-.458 1.013-.42.401.02.688.134.898.268v-.994c0-.554.44-.993.994-.993h5.696l.038.229c.038.191.84 4.68-.822 6.8a2.756 2.756 0 01-2.045 1.07c-.115 0-.268.02-.401.02zm-3.766-3.878l.038.267c.02.134.497 3.248 4.11 3 .688-.039 1.223-.325 1.644-.86 1.3-1.662.879-5.177.745-6.113h-5.218c-.23 0-.42.19-.42.42v1.433a.367.367 0 01-.268.363.363.363 0 01-.42-.134c-.173-.23-.44-.344-.822-.363-.249-.02-.421.057-.517.191-.21.287-.172.84-.038 1.204.249.668.88.592.899.592h.267z"
        ></path>
      </g>
    </svg>
  );
}

export default CallRequestModalSvg;